/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationInputOAuthDataModel
 */
export interface FrontApplicationInputOAuthDataModel {
    /**
     * Id
     * @type {string}
     * @memberof FrontApplicationInputOAuthDataModel
     */
    id: string;
    /**
     * Mail
     * @type {string}
     * @memberof FrontApplicationInputOAuthDataModel
     */
    email: string;
}

/**
 * Check if a given object implements the FrontApplicationInputOAuthDataModel interface.
 */
export function instanceOfFrontApplicationInputOAuthDataModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function FrontApplicationInputOAuthDataModelFromJSON(json: any): FrontApplicationInputOAuthDataModel {
    return FrontApplicationInputOAuthDataModelFromJSONTyped(json, false);
}

export function FrontApplicationInputOAuthDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationInputOAuthDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
    };
}

export function FrontApplicationInputOAuthDataModelToJSON(value?: FrontApplicationInputOAuthDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
    };
}

